module.exports = __webpack_public_path__ + "img/pintura.f2559210.png";